import { useState, useEffect } from 'react';
import { BREAKPOINT } from '@constants';

/**
 * A React hook that determines if the current viewport width is desktop-sized
 * @param {number} [customSize=768] - Optional breakpoint in pixels to determine desktop view (defaults to 768px)
 * @returns {boolean} True if viewport width is greater than the breakpoint
 */
export default function useDesktop(customSize?: number) {
  const [desktop, setDesktop] = useState(true);

  useEffect(() => {
    showOnDesktop();
    window.addEventListener('resize', showOnDesktop, { passive: true });

    return () => {
      window.removeEventListener('resize', showOnDesktop);
    };
  }, []);

  function showOnDesktop() {
    if (window.innerWidth > (customSize || BREAKPOINT.tablet)) {
      setDesktop(true);
    } else {
      setDesktop(false);
    }
  }

  return desktop;
}
